//import XLSX from 'xlsx'

const XLSX = require("xlsx");
const moment = require("moment");

const load_specs = require("./specs/specs_parser").default;

const company_specs = load_specs("company.yml");
const process_specs = load_specs("process.yml");
const measureset_specs = load_specs("measureSet.yml");

const export_spec = {
  sheets: ["process", "measureset", "measuresetmeasure"],
  process: {
    specs: process_specs.fields.reduce((acc, cur, i) => {
      acc[cur.name] = cur;
      return acc;
    }, {}),
    fields: [
      "seq_nr",
      "text_header",
      "data_category",
      "dept_resp",
      "recipient_category",
      "delete_period",
      "damage_scenario",
      "risk_probability",
      "damage_rate",
      "victim_risk",
      "text_problem",
      "legal_basis",
      "text_legal",
      "assessment_necessary",
      "measuresets",
    ],
  },
  measureset: {
    specs: measureset_specs.fields.reduce((acc, cur, i) => {
      acc[cur.name] = cur;
      return acc;
    }, {}),
    fields: ["seq_nr", "type", "description", "commentatory"],
  },
};

function addSheet(wb, name, rows, header) {
  var ws = XLSX.utils.json_to_sheet(rows, {
    header: header,
  });
  wb.SheetNames.push(name);
  wb.Sheets[name] = ws;
}

function addToDos(wb, company) {
  var procs = company.processes.items;
  procs.sort((a, b) => (a.seq_nr > b.seq_nr ? 1 : -1));
  var header = ["Verfahren Nr", "Verfahren Name", "ToDo", "ToDo Beschreibung", "Erledigt"];
  var todos = [];
  for (var proc of procs) {
    for (todo of proc.measures.items) {
      var todo = {
        "Verfahren Nr": proc.seq_nr,
        "Verfahren Name": proc.text_header,
        ToDo: todo.label,
        "ToDo Beschreibung": todo.description,
        Erledigt: todo.status === "COMPLETED" ? "JA" : "NEIN",
      };
      todos.push(todo);
    }
  }
  addSheet(wb, "ToDo Liste", todos, header);
}

function generateToDoXLS(company, printOptions, callback) {
  var wb = XLSX.utils.book_new();
  addToDos(wb, company);
  var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
  var wbout = XLSX.write(wb, wopts);

  callback(wbout, moment().format());
}

export { generateToDoXLS };
